
import { defineComponent } from '@nuxtjs/composition-api';
import { mapGetters, mapState } from 'vuex';
import WarRoomComments from '@/components/partials/war-room/WarRoomComments/WarRoomComments.vue';
import BravadoText from '~/components/common/BravadoText/BravadoText.vue';
import { waitForImages } from '~/components/utils/browser/image';

export default defineComponent({
  name: 'PostSingleCommentPage',
  components: { WarRoomComments, BravadoText },
  // Don't fetch on server to manage scroll position properly
  fetchOnServer: false,
  data() {
    return {
      scrollPerformed: false,
    };
  },
  async fetch() {
    try {
      await this.$store.dispatch('warRoom/fetchCommentsSubtree', {
        postSlug: this.$route.params.postSlug,
        commentId: this.$route.params.commentId,
        query: this.$route.query,
      });
      if (process.client) await this.scrollToActiveComment();
    } catch (e) {
      this.$utils.nuxtErrorPage(e);
      this.$sentryUtils.error(e);
    }
  },
  computed: {
    ...mapState('warRoom', ['commentTree']),
    ...mapGetters('warRoom', ['currentPost']),
    postLink(): string {
      return `${this.$pages.POSTS_PAGE.path}/${this.$route.params.postSlug}?comment=true`;
    },
  },
  watch: {
    '$route.params.commentId'() {
      this.$fetch();
    },
    '$route.query.sort_comments'() {
      this.$fetch();
    },
  },
  methods: {
    async scrollToActiveComment() {
      if (this.$route.params.commentId) {
        // in a big comment tree browser sometimes does not scroll to the exact comment if we trigger this method
        // in mounted hook of a comment component
        // here we wait until all child components are mounted and only then begin scrolling to the comment
        const commentEl = document.getElementById(`comment-${this.$route.params.commentId}`);
        if (commentEl) {
          this.scrollPerformed = true;

          // wait for content images to be loaded to avoid layout shift scoll position issue
          await waitForImages(Array.from(document.querySelectorAll('.war-room-post-content img')));

          this.$nextTick(() => {
            commentEl.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
            });
          });
        }
      }
    },
  },
});
